import React from "react";
import {StyledSection8Container} from "./Section8.styles";
import {MapContainer, Polygon, TileLayer} from "react-leaflet";
import {MyButton} from "../../../common/MyButton/MyButton";
import {useNavigate} from "react-router-dom";
import {AreaIcon} from "../../../../assets";
import {Grid} from "antd";

const {useBreakpoint} = Grid;

export const Section8 = () => {

    const screens = useBreakpoint();

    const navigate = useNavigate();


    const center = [33.0593, -117.1307]

    const polygon = [
        [32.5705412, -116.7723083],
        [32.5381306, -117.2090149],
        [32.7497451, -117.3298645],
        [33.090391, -117.4150085],
        [33.1582477, -117.4390411],
        [33.332823, -117.3538971],
        [33.6734971, -117.3930359],
        [33.7066339, -116.9982147],
        [33.4537869, -116.9446564],
        [32.8242111, -116.7489624],
        [32.5745917, -116.7736816],
    ]

    return (
        <StyledSection8Container>
            <MapContainer center={center} zoom={9} scrollWheelZoom={false} style={{width: "100%", height: 900}}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Polygon pathOptions={{color: "rgba(0, 51, 153, 1)", weight: 1}} positions={polygon} />
            </MapContainer>
            <MyButton onClick={() => navigate("/area")} style={{position: "absolute", bottom: 40, right: !screens.sm ? 60 : !screens.lg ? 20 : 200, zIndex: 2}} type="primary"><AreaIcon /> Service Area</MyButton>
        </StyledSection8Container>
    )
}